'use strict';

(function () {
  angular
    .module('specsguardApp')
    .controller('sgOptionListCtrl', sgOptionListCtrl);

  sgOptionListCtrl.$inject = ['Labels'];

  function sgOptionListCtrl (Labels) {
    const vm = this;

    //
    // Initialization
    //
    vm.$onInit = function () {
      vm.LABELS = Labels;

      vm.ngModelCtrl.$render = () => {
        vm.model = vm.ngModelCtrl.$viewValue;
      };
    };

    vm.addSelectOption = () => {
      vm.selectOption = true;
    };

    vm.cancelAddSelect = function () {
      vm.selectOption = false;
      vm.selectOptionValue = '';
    };

    vm.saveSelectOption = function () {
      vm.model = angular.isArray(vm.model) ? vm.model : [];
      vm.model.push({
        id: vm.model.length + 1,
        name: vm.selectOptionValue,
        active: true,
      });
      vm.selectOption = false;
      vm.selectOptionValue = '';

      // Propgate the value change
      vm.ngModelCtrl.$setViewValue(vm.model);
    };

    vm.removeOption = (option) => {
      const idx = vm.model.indexOf(option);
      if (idx > -1) {
        vm.model.splice(idx, 1);
      }

      // Propgate the value change
      vm.ngModelCtrl.$setViewValue(vm.model);
    };
  }
})();
